import React from 'react';
import QCategoria from '../../libQuestionario/pages/QCategoria';
import MRHeader from './components/MRHeader';
import { API_SERVICES } from '..';

const MRCategoria = () => {

  return <QCategoria 
    homeRoute={API_SERVICES.MR.HOME_ROUTE}
    root={API_SERVICES.MR.ROOT}
    title={API_SERVICES.MR.NOME}
    headerComponent={<MRHeader label="Seleziona un modello o una categoria" />}
  />
}

export default MRCategoria